/* eslint-disable */

$(document).ready(function () {
  $(".owl-carousel-also").owlCarousel({
    nav: false,
    autoHeight: true,
    responsive: {
      0: {
        items: 1
      },
      768: {
        items: 2,
        autoHeight: true
      },
      991: {
        items: 3,
        autoHeight: true
      }
    }
  });
});
